import React, { useContext } from "react";
import moment from 'moment';
import { makeStyles } from "@material-ui/core/styles";
import { AppContext } from "store/AppContext";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import EventIcon from '@material-ui/icons/Event';
import TodayIcon from '@material-ui/icons/Today';

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  chip: {
    marginBottom: theme.spacing(),
  },
  dates: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: '4px',
  },
}));

const styles = {
  active: {
    border: '4px solid #7796d2'
  },
};

export default function OpinKosningCard(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { kosning, handleSelect } = props;

  return (
    <Card
      className={classes.card}
      style={{
        ...(kosning.id === context.activeKosning.get.id ? styles.active : {})
      }}
    >
      <CardContent>
        <Chip
          className={classes.chip}
          color="secondary"
          variant="outlined"
          size="small"
          label={kosning.tegundLysing}
        />
        <Typography variant="h5" component="h2">
          {kosning.lysing}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          Kosningaaldur: {kosning.kosningaaldur}
        </Typography>
        <div className={classes.dates}>
          <TodayIcon className={classes.icon} fontSize="small" />
          <Typography
            variant="body2"
            style={{ borderBottom: "1px solid lightgray" }}
          >
            Kjörskrárdagur:{" "}
            <strong>
              {moment(kosning.kjorskrardagur).format("DD.MM.YYYY")}
            </strong>
          </Typography>
        </div>
        <div className={classes.dates}>
          <EventIcon className={classes.icon} fontSize="small" />
          <Typography variant="body2">
            Kosningadagur:{" "}
            <strong>
              {moment(kosning.kosningadagur).format("DD.MM.YYYY")}
            </strong>
          </Typography>
        </div>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => handleSelect(kosning)}
        >
          Velja kosningu
        </Button>
      </CardActions>
    </Card>
  );
}
